import React, { useState, useEffect } from "react";
import makeStyles from '@mui/styles/makeStyles';
import _ from "lodash";
import { useTranslation } from "react-i18next";
import EnterpriseLogo from "Assets/Images/enterprise_logo.jpg";
import NationalLogo from "Assets/Images/national_logo.jpg";
import ExtraEditingDialog from "./extraEditingDialog";
import { isTablet, isMobile } from "react-device-detect";
import { getLocaleCurrency } from "helpers/localization";
import { authService } from "services/authService";
import { ReactComponent as ElectricCarIcon } from "Assets/Images/ElectricCarIcon.svg";
import { useSelector } from "react-redux";
import { AppState } from "components/store/reducers/rootReducer";

import {
  Grid,
  Paper,
  Button,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { FieldProps, FormikErrors, FormikTouched } from "formik";
import { translateOTA } from "helpers/otaTranslateHelper";

interface CarClassProps {
  label: string;
  name: string;
  carInfo: any;
  carKey: string;
  mainIndex: number;
  showEmission:boolean;
  handleCarSelect: (car: any, index: number) => void;
  handleCarExtras: (key: string, extras: any) => void;
  errors?: FormikErrors<{
    [field: string]: any;
  }>;
  touched?: FormikTouched<{
    [field: string]: any;
  }>;
  autofocus?: boolean;
  disabled?: boolean;
  locale?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    // padding: theme.spacing(0),
    textAlign: "center",
    color: theme.palette.text.secondary,
    display: "flex",
    flex: 1,
    height: "100%",
    overflowX: "auto",
  },
  responsive: {
    width: "50%",
    height: "auto",
    //  textAlign:"center",
    border: "0px red solid",
  },
}));

const DoorIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24pt"
      height="24pt"
      viewBox="0 0 24 24"
      fill="#616263"
      version="1.1"
      aria-hidden="true"
    >
      <g>
        <path
          // style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
          d="M 23.746094 0.460938 C 23.519531 0.171875 23.167969 0 22.800781 0 L 10.800781 0 C 10.480469 0 10.175781 0.125 9.953125 0.351562 L 0.351562 9.953125 C 0.125 10.175781 0 10.480469 0 10.800781 L 0 22.800781 C 0 23.460938 0.539062 24 1.199219 24 L 20.398438 24 C 21.0625 24 21.601562 23.460938 21.601562 22.800781 L 21.601562 10.949219 L 23.964844 1.492188 C 24.054688 1.132812 23.972656 0.753906 23.746094 0.460938 Z M 20.398438 22.800781 L 1.199219 22.800781 L 1.199219 12 L 20.398438 12 Z M 20.398438 10.800781 L 1.199219 10.800781 L 10.800781 1.199219 L 22.800781 1.199219 Z M 20.398438 10.800781 "
        />
        <path
          // style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
          d="M 15.601562 13.199219 L 19.199219 13.199219 L 19.199219 14.398438 L 15.601562 14.398438 Z M 15.601562 13.199219 "
        />
      </g>
    </svg>
  );
};
const LuggageIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24pt"
      height="24pt"
      viewBox="0 0 24 24"
      fill="#616263"
      version="1.1"
      aria-hidden="true"
    >
      <g>
        <path
          //style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
          d="M 17.980469 6.390625 L 16.5 6.390625 L 16.5 1.917969 C 16.5 0.859375 15.640625 0 14.582031 0 L 9.417969 0 C 8.359375 0 7.5 0.859375 7.5 1.917969 L 7.5 6.390625 L 6.019531 6.390625 C 5.09375 6.390625 4.347656 7.140625 4.347656 8.066406 L 4.347656 20.707031 C 4.347656 21.628906 5.097656 22.378906 6.019531 22.378906 L 6.246094 22.378906 L 6.246094 23.59375 C 6.246094 23.820312 6.425781 24 6.648438 24 L 8.5625 24 C 8.789062 24 8.96875 23.820312 8.96875 23.59375 L 8.96875 22.378906 L 15.03125 22.378906 L 15.03125 23.59375 C 15.03125 23.820312 15.214844 24 15.4375 24 L 17.351562 24 C 17.574219 24 17.753906 23.820312 17.753906 23.59375 L 17.753906 22.378906 L 17.980469 22.378906 C 18.90625 22.378906 19.652344 21.628906 19.652344 20.707031 L 19.652344 8.066406 C 19.652344 7.140625 18.90625 6.390625 17.980469 6.390625 Z M 15.222656 6.390625 L 8.777344 6.390625 L 8.777344 1.917969 C 8.777344 1.566406 9.066406 1.277344 9.417969 1.277344 L 14.582031 1.277344 C 14.933594 1.277344 15.222656 1.566406 15.222656 1.917969 Z M 15.222656 6.390625 "
        />
      </g>
    </svg>
  );
};
const AirBagIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24pt"
      height="24pt"
      viewBox="0 0 24 24"
      fill="#616263"
      version="1.1"
      aria-hidden="true"
    >
      <g>
        {/* <path
          //style="stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
          d="M 12 6 C 12 2.691406 9.308594 0 6 0 C 2.691406 0 0 2.691406 0 6 C 0 9.308594 2.691406 12 6 12 C 9.308594 12 12 9.308594 12 6 Z M 12 6 "
       />*/}
        <path
          // style="stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
          d="M 18 5.601562 C 19.324219 5.601562 20.398438 4.523438 20.398438 3.199219 C 20.398438 1.875 19.324219 0.800781 18 0.800781 C 16.675781 0.800781 15.601562 1.875 15.601562 3.199219 C 15.601562 4.523438 16.675781 5.601562 18 5.601562 Z M 18 1.601562 C 18.882812 1.601562 19.601562 2.316406 19.601562 3.199219 C 19.601562 4.082031 18.882812 4.800781 18 4.800781 C 17.117188 4.800781 16.398438 4.082031 16.398438 3.199219 C 16.398438 2.316406 17.117188 1.601562 18 1.601562 Z M 18 1.601562 "
        />
        <path
          // style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
          d="M 23.878906 4.945312 C 23.957031 4.871094 24 4.765625 24 4.65625 L 24 2.398438 C 24 2.238281 23.902344 2.09375 23.753906 2.03125 C 23.605469 1.96875 23.433594 2.003906 23.316406 2.117188 L 18.230469 7.167969 C 17.859375 6.675781 17.34375 6.320312 16.738281 6.15625 C 15.28125 5.753906 13.777344 6.570312 13.316406 8.011719 L 11.769531 12.875 L 11.484375 12.585938 C 11.332031 12.4375 11.066406 12.4375 10.917969 12.585938 L 9.785156 13.71875 C 9.628906 13.875 9.628906 14.125 9.785156 14.28125 L 10.226562 14.722656 L 6.425781 14.25 C 5.839844 14.175781 5.273438 14.550781 5.117188 15.125 L 3.257812 21.941406 C 3.136719 22.382812 3.210938 22.859375 3.457031 23.25 C 3.707031 23.636719 4.109375 23.902344 4.5625 23.976562 C 4.652344 23.992188 4.742188 24 4.828125 24 C 5.53125 24 6.171875 23.542969 6.386719 22.855469 L 7.859375 18.140625 C 7.917969 17.953125 8.109375 17.832031 8.308594 17.863281 L 14.3125 18.8125 L 19.386719 23.882812 C 19.460938 23.957031 19.5625 24 19.667969 24 C 19.773438 24 19.875 23.957031 19.953125 23.882812 L 21.082031 22.75 C 21.238281 22.59375 21.238281 22.34375 21.082031 22.1875 L 16.300781 17.402344 L 18.554688 10.09375 Z M 8.433594 17.074219 C 7.847656 16.980469 7.273438 17.335938 7.097656 17.902344 L 5.625 22.617188 C 5.5 23.011719 5.097656 23.257812 4.695312 23.1875 C 4.460938 23.148438 4.261719 23.019531 4.132812 22.816406 C 4.003906 22.617188 3.96875 22.378906 4.03125 22.152344 L 5.886719 15.335938 C 5.9375 15.160156 6.097656 15.039062 6.277344 15.039062 C 6.292969 15.039062 6.3125 15.039062 6.328125 15.042969 L 11.148438 15.644531 L 13.351562 17.847656 Z M 17.992188 9.074219 C 17.976562 9.203125 17.953125 9.328125 17.914062 9.457031 L 17.820312 9.757812 L 15.660156 16.761719 L 12.410156 13.511719 L 14.078125 8.253906 C 14.410156 7.222656 15.484375 6.640625 16.527344 6.925781 C 17.054688 7.070312 17.492188 7.417969 17.753906 7.898438 C 17.789062 7.957031 17.808594 8.019531 17.832031 8.078125 C 17.867188 8.160156 17.902344 8.238281 17.925781 8.320312 C 17.933594 8.359375 17.941406 8.402344 17.949219 8.441406 C 17.96875 8.523438 17.988281 8.609375 17.992188 8.695312 C 18 8.746094 17.992188 8.800781 17.992188 8.851562 C 17.996094 8.925781 18 9 17.992188 9.074219 Z M 17.992188 9.074219 "
        />
      </g>
    </svg>
  );
};
const BrandInfoComponent = (props) => {
  const { t } = useTranslation();
  const [isExtraUpdated, setIsExtraUpdated] = React.useState(false);
  const [extraTotal, setExtraTotal] = React.useState(0.0);
  const mandatoryExtra = props.carInfo?.brandInfo[0].includedExtras;
  const selectedExtra = props.carInfo?.brandInfo[0].selectedExtras;
  const locale = authService.getUserLocale();
  const updateTotal = () => {
    setIsExtraUpdated(!isExtraUpdated);
    getExtraTotal(props.brandInfo.selectedExtras);
  };
  const getMileageMsg = (brandInfo) => {
    if (brandInfo.distance.unlimited){
      return t("carClasses.labelUnlimitedDistance");
    } else {
      let rateWithCurrency = brandInfo.additionalRentalCharge.find(x => x.description === "MILEAGE CHARGE").rateWithCurrency
      let mileageUnit = brandInfo.distance.unit.toUpperCase() == "MILE" ? "MI" : "KM";
      return t("carClasses.labelLimitedDistance", { quantity: brandInfo.distance.quantity, unit: mileageUnit, rateWithCurrency: rateWithCurrency});

    }
  };
  const getExtraTotal = (extras) => {
    let total = 0;

    if (extras && extras.length > 0) {
      total = _.sumBy(extras, function (ex: any) {
        return ex.quantity > 0 ? ex.unitPrice * ex.quantity : ex.unitPrice;
      });
    }

    setExtraTotal(total > 0 ? Math.round(total * 100) / 100 : 0);
  };

  React.useEffect(() => {
    getExtraTotal(props.brandInfo.selectedExtras);
  }, [isExtraUpdated, extraTotal, props.brandInfo.selectedExtras]);
  return (
    <Grid
      container
      justifyContent="flex-start"
      direction="row"
      alignItems="flex-start"
    >
      <Grid item xs={12}>
        <img
          src={props.brandInfo.brand === "ET" ? EnterpriseLogo : NationalLogo}
          style={{ height: "1.5em", marginTop: 4 }}
          alt={
            props.brandInfo.brand === "ET"
              ? t("Res.EnterpriseFullBrandName")
              : t("Res.NationalFullBrandName")
          }
        />
      </Grid>
      <Grid item xs={12}>
        <br />
        <Typography
          variant={"body2"}
          style={{ color: "#000", fontWeight: "bold", fontSize: "16px" }}
        >
          {Number(props.brandInfo.baseRatePrice).toLocaleString(props.locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          {props.brandInfo.currency}
        </Typography>
        <Typography variant={"body1"} style={{ color: "#000" }}>
          {t("carClasses.labelEstimatedRentalTotal")}
        </Typography>
        <Typography  id="mileageCaps" variant={"body1"} style={{ whiteSpace: "pre-line" }}>
          {getMileageMsg(props.brandInfo)}
        </Typography>
        <br />
        <Grid item xs={12}>
          <Button
            variant={props.brandInfo.isSelected ? "contained" : "outlined"}
            color={props.brandInfo.isSelected ? "primary" : "inherit"}
            aria-label={t(
              props.brandInfo.isSelected
                ? "carClasses.labelBtnSelected"
                : "carClasses.labelBtnSelect",
              {
                carmodel:
                  props.carInfo.modelCode +
                  ", " +
                  props.carInfo.modelDescription,
              }
            )}
            id={
              props.brandInfo.brand === "ET"
                ? "carClassButtonET" + props.mainIndex
                : "carClassButtonZL" + props.mainIndex
            }
            onClick={() => {
              if (props.handleSelect) {
                props.handleSelect(props.brandInfo, props.carKey);
              }
            }}
          >
            {props.brandInfo.isSelected
              ? t("carClasses.labelBtnSelected")
              : t("carClasses.labelBtnSelect")}
          </Button>
        </Grid>
        <br />
        <Box
          alignContent="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant={"body1"}>
            {t("carClasses.labelExtras")}
          </Typography>
          <ExtraEditingDialog
            brandInfo={props.brandInfo}
            includedExtras={mandatoryExtra}
            selectedExtras={selectedExtra}
            modelCode={props.carInfo.modelCode}
            modelDescription={props.carInfo.modelDescription}
            updateTotal={updateTotal}
            updateExtras={props.updateExtras}
            mainIndex={props.mainIndex}
          />
        </Box>
        <Typography variant={"body2"} style={{ marginBottom: 5 }}>
          {extraTotal > 0
            ? getLocaleCurrency(extraTotal.toString(), locale, "")
            : ""}
          {" " + props.brandInfo.currency}
        </Typography>
      </Grid>
    </Grid>
  );
};
const EtdCarClasses: React.FC<CarClassProps & FieldProps> = ({
  label,
  errors,
  touched,
  autofocus = false,
  disabled = false,
  handleCarSelect,
  handleCarExtras,
  carInfo,
  carKey,
  mainIndex,
  showEmission,
  locale,
  field: { name, onChange, onBlur: _, ...field },
  form: { setFieldValue, setFieldTouched },
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmXs = useMediaQuery(theme.breakpoints.down('lg'));
  const { t } = useTranslation();
  const { co2dict } = useSelector((state: AppState) => state.co2Dict);

  const handleChange = (date) => {
    setFieldValue(name, date);
  };

  const handleSelect = (data, index) => {
    handleCarSelect({ car: data }, index);
  };
  const handleSelectedExtras = (extras, key) => {
    handleCarExtras(key, extras);
  };
  React.useEffect(() => {}, []);
  const prefBorder = carInfo.preferred ? "2px solid #000" : "1px solid #ccc";
  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="stretch"
        spacing={0}
        style={{
          border: prefBorder,
          marginRight: "1em",
          // maxHeight: isSmXs ? "750px" : "250px",
        }}
      >
        {!(isMobile || isTablet) ? (
          <Grid
            item
            xs={isSmXs ? 12 : 4}
            style={{ borderRight: "1px solid #ccc" }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
              justifyContent="space-between"
              width="100%"
              height="100%"
            >
              <Box width="100%" pt={2}>
                <h3 style={{ margin: 0, padding: 0 }}>
                  <img
                    alt={carInfo.modelCode + ", " + carInfo.modelDescription}
                    title={carInfo.modelCode + ", " + carInfo.modelDescription}
                    className={classes.responsive}
                    src={carInfo.pictureUrl}
                  />
                </h3>
              </Box>
              <Box width="100%">
                <Grid
                  container
                  item
                  xs={12}
                  style={{
                    alignItems: "center",
                    verticalAlign: "bottom",
                    width: "100%",
                  }}
                >
                  <Grid item xs={4} sm={3}>
                    <Typography
                      variant={"body2"}
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      {carInfo.doorCount && carInfo.doorCount > 0
                        ? carInfo.doorCount.toString()
                        : "-"}{" "}
                      {carInfo.doorCount && carInfo.doorCount === 1
                        ? t("carClasses.labelDoorSingular")
                        : t("carClasses.labelDoorPlural")}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} sm={1}>
                    {" "}
                    <DoorIcon />
                  </Grid>

                  <Grid item xs={4} sm={3}>
                    <Typography
                      variant={"body2"}
                      style={{
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {carInfo.passengerQt && carInfo.passengerQt > 0
                        ? carInfo.passengerQt.toString()
                        : "-"}{" "}
                      {carInfo.passengerQt && carInfo.passengerQt === 1
                        ? t("carClasses.labelPeopleSingular")
                        : t("carClasses.labelPeoplePlural")}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} sm={1}>
                    <AirBagIcon style={{ textAlign: "center" }} />
                  </Grid>

                  <Grid item xs={4} sm={3} style={{ textAlign: "center" }}>
                    <Typography
                      variant={"body2"}
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      {carInfo.baggageQt && carInfo.baggageQt > 0
                        ? carInfo.baggageQt
                        : "-"}{" "}
                      {carInfo.baggageQt && carInfo.baggageQt === 1
                        ? t("carClasses.labelBagSingular")
                        : t("carClasses.labelBagPlural")}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} sm={1} style={{ textAlign: "center" }}>
                    <LuggageIcon />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={isSmXs ? 12 : 4} style={{ height: "100%" }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center"
          >
            <Box width="100%" pt={0}>
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#006639",
                  textAlign: "center",
                }}
              >
                {carInfo.preferred ? (
                  <Typography
                    variant={"body2"}
                    style={{
                      margin: 0,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#fff",
                      padding: 4,
                    }}
                  >
                    {t("carClasses.labelPreferredChoice")}
                  </Typography>
                ) : (
                  ""
                )}
              </div>
              <Typography
                variant={"body2"}
                style={{
                  marginTop: "10px",
                  marginBottom: 0,
                  color: "#006639",
                  fontSize: "24px",
                  fontWeight: "bold",
                  padding: 8,
                }}
              >
                {carInfo.modelCode}
              </Typography>
              <Typography
                variant={"body2"}
                style={{
                  marginTop: "10px",
                  marginBottom: 0,
                  fontSize: "16px",
                  fontWeight: "bold",
                  padding: 2,
                }}
              >
                {translateOTA(carInfo.modelDescription,t).toUpperCase()}
              </Typography>
              <br />
              {carInfo.modelCode?.slice(-1) === "E" ? (
                <Typography
                  variant={"body2"}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "10px",
                    marginBottom: 0,
                    fontSize: "16px",
                    fontWeight: "bold",
                    padding: 2,
                  }}
                >
                  <ElectricCarIcon width="20pt" height="20pt" />
                  &nbsp;{t("carClasses.logoElectric")}
                </Typography>
              ) : (
                ""
              )}
              <Typography
                variant={"body2"}
                style={{
                  marginTop: "10px",
                  marginBottom: 0,
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: 2,
                }}
              >
                {carInfo.manual
                  ? t("carClasses.labelManual")
                  : t("carClasses.labelAutomatic")}
              </Typography>
              {showEmission && 
              <Typography
                id={"co2rate" + mainIndex.toString()}
                variant={"body2"}
                style={{
                  marginTop: "10px",
                  marginBottom: 0,
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: 2,
                }}
              >
                CO2** : {co2dict.get(carInfo.modelCode) ?? "-"}
              </Typography>
              }
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={isSmXs ? 12 : 4}
          style={{ borderLeft: "1px solid #ccc" }}
        >
          <Paper className={classes.paper}>
            {carInfo.brandInfo &&
              carInfo.brandInfo?.map((brand, i) => (
                <BrandInfoComponent
                  brandInfo={brand}
                  carInfo={carInfo}
                  handleSelect={handleSelect}
                  updateExtras={handleSelectedExtras}
                  key={i}
                  carKey={carKey}
                  mainIndex={mainIndex}
                  locale={locale ?? "en-GB"}
                />
              ))}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default EtdCarClasses;
